"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepayRecord = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var jyEduStages_1 = require("../../model/jyEduStages");
var service_1 = require("../../../library/base/service");
var RepayRecord = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RepayRecord, _super);
    function RepayRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '还款记录接口';
        _this.code = '101102';
        _this.desc = '还款记录接口';
        _this.requestParams = new jyEduStages_1.RepayRecordRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return RepayRecord;
}(service_1.BaseService));
exports.RepayRecord = RepayRecord;
//# sourceMappingURL=repayRecord.js.map